import { useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';
import { ApplicationState } from '../../../../../store';
import { PrevNextButtons } from '../../../../PrevNextButtons';
import { FileList } from '../../../../FileList/FileList';

import { useNavigate } from 'react-router-dom';
import ApplicantHeader from '../../../../../components/molecules/applicantHeader';
import { SectionHeader, SectionTitles } from '@/components/molecules/SectionHeader';
import { getApplicationData } from '../helpers';
import { useTaskNavigation } from '@/hooks/useTaskNavigation';
import { useTaskRouteGuard } from '@/hooks/useTaskRouteGuard';
import { TaskLoadingSkeleton } from '@/components/molecules/TaskLoadingSkeleton';
import { useTranslation } from "react-i18next";

export default function ResearchProposal() {
    const { t } = useTranslation('common');
  const { allDocuments } = useSelector((state: ApplicationState) => state.apply);
  const navigate = useNavigate();
  const { nextRoute, previousRoute } = useTaskNavigation();

  const { application } = useSelector((state: ApplicationState) => state.apply);

  const { initial, current } = getApplicationData(application);
  const { isLoading } = useTaskRouteGuard('/research-proposal');

  if (isLoading) {
    return <TaskLoadingSkeleton />;
  }
  // Assuming hasResearchProposalDocument is present in the application data
  // You might need to update the helper or types if it's not
  const { hasResearchProposalDocument } = current;
  const initialHasResearchProposalDocument = initial.hasResearchProposalDocument;

  const hasNoResearchProposal = hasResearchProposalDocument === false && initialHasResearchProposalDocument === false;

  const hasNoDocument = allDocuments?.researchProposal === undefined || allDocuments?.researchProposal.length === 0;

  const showNoResearchProposalAlert = hasNoResearchProposal && hasNoDocument;

  return (
    <>
      <ApplicantHeader pageName="Application" />
      <Box>
        <SectionHeader title={SectionTitles.RESEARCH_PROPOSAL} />

        <FileList files={allDocuments?.researchProposal || []} />

        <Box>
          {showNoResearchProposalAlert && (
            <Box bgColor="utility.100" px={5} py={3} color="muted">
              {t('common:theApplicantHasNoDataForThisTask')}
                                      </Box>
          )}
        </Box>

        <Box mt={6}>
          <PrevNextButtons
            onPrevious={previousRoute ? () => navigate(previousRoute) : undefined}
            onNext={nextRoute ? () => navigate(nextRoute) : undefined}
          />
        </Box>
      </Box>
    </>
  );
}
